import { ADD_USER, UPLOAD_CSV_FILE, UPLOAD_USERS, USER_DELETE, USER_EDIT, USER_LIST, USER_STATUS, USER_VIEW } from "./types";

export const userListAction = (data, onSuccess, onError) => {
    return {
        type: USER_LIST,
        data,
        onSuccess,
        onError,
    };
};
export const addUserAction = (data, onSuccess, onError) => {
    return {
        type: ADD_USER,
        data,
        onSuccess,
        onError
    }
};

export const userEdit = (data, onSuccess, onError) => {
    return {
        type: USER_EDIT,
        data,
        onSuccess,
        onError,
    };
};


export const userDelete = (data, onSuccess, onError) => {
    return {
        type: USER_DELETE,
        data,
        onSuccess,
        onError,
    };
};

export const userView = (data, onSuccess, onError) => {
    return {
        type: USER_VIEW,
        data,
        onSuccess,
        onError,
    };
};

export const userStatus = (data, onSuccess, onError) => {
    return {
        type: USER_STATUS,
        data,
        onSuccess,
        onError,
    };
};

export const uploadCSVFile = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_CSV_FILE,
        file,
        onSuccess,
        onError,
    };
};

export const uploadUsersAction = (data, onSuccess, onError) => {
    return {
        type: UPLOAD_USERS,
        data,
        onSuccess,
        onError
    }
};